import { getLoggedInUser } from './auth';

function AdminGuard({ children }) {
  let user = getLoggedInUser();
  return user.role === 'admin' ? children : null;
}

export default AdminGuard;
